import { render, staticRenderFns } from "./FormattedPrice.vue?vue&type=template&id=361899f7&scoped=true"
import script from "./FormattedPrice.vue?vue&type=script&lang=ts"
export * from "./FormattedPrice.vue?vue&type=script&lang=ts"
import style0 from "./FormattedPrice.vue?vue&type=style&index=0&id=361899f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361899f7",
  null
  
)

export default component.exports